const close = require('../assets/images/close-icon.png');

const initPopupStyle = () => {
  // 检查样式是否已经存在，若不存在则创建
  const isExistStyle = !!document.querySelector('style[name="popup-style"]');
  if (!isExistStyle) {
    const style = document.createElement('style');
    style.setAttribute('name', 'popup-style');
    // 定义popup的各种样式
    const contentStyle =
      '.popup-content{position:fixed;width:100vw;height:100vh;top:0;left:0;display:flex;align-items:center;justify-content:center;z-index:99999;}';
    const maskStyle =
      '.popup-mask{position:absolute;width:100%;height:100%;top:0;left:0;background-color:rgba(0,0,0,.3);z-index:-1;}';
    const boxStyle =
      '.popup-box{position:relative;border-radius:5px;background-color:#fff; width: 85vw; max-width: 360px;padding:15px;display:flex;flex-direction:column;align-items:center;justify-content:center;}';
    const posterStyle = '.popup-poster{width: 100%;}';
    const closeIconStyle =
      '.popup-close-icon{position:absolute;top:25px;right:25px;width:16px;height:16px;cursor:pointer;}';
    const textStyle = '.popup-text{margin-top: 5px;color:#999;font-size:14px;}';
    const zoomInKeyframes =
      '@keyframes zoom-in{from {transform: scale(0.1);} to {transform: scale(1);}}';
    const zoomOutKeyframes =
      '@keyframes zoom-out{from {transform: scale(1);} to {transform: scale(0.1);}}';
    const boxZoomInStyle = '.popup-box-zoom-in{animation: zoom-in 0.35s;}';
    const boxZoomOutStyle = '.popup-box-zoom-out{animation: zoom-out 0.35s;}';
    const fadeInKeyframes =
      '@keyframes fade-in{from {opacity: 0;} to {opacity: 1;}}';
    const fadeOutKeyframes =
      '@keyframes fade-out{from {opacity: 1;} to {opacity: 0;}}';
    const maskFadeInStyle = '.popup-mask-fade-in{animation: fade-in 0.35s;}';
    const maskFadeOutStyle = '.popup-mask-fade-out{animation: fade-out 0.35s;}';
    style.innerHTML = `${contentStyle}${maskStyle}${boxStyle}${closeIconStyle}${posterStyle}${textStyle}${zoomInKeyframes}${zoomOutKeyframes}${boxZoomInStyle}${boxZoomOutStyle}${maskFadeInStyle}${maskFadeOutStyle}${fadeInKeyframes}${fadeOutKeyframes}`;
    document.head.append(style);
  }
};
const wheelHandler = (evt: Event) => {
  if ((evt.target as HTMLElement).tagName === 'BODY') {
    evt.preventDefault();
  }
};

export const hidePosterPopup = () => {
  const maskNode = document.querySelector('.popup-mask');
  const boxNode = document.querySelector('.popup-box');
  const closeNode = document.querySelector('.popup-close-icon')!;
  if (maskNode && boxNode && closeNode) {
    maskNode.removeEventListener('click', hidePosterPopup);
    closeNode.removeEventListener('click', hidePosterPopup);
    maskNode.className = 'popup-mask popup-mask-fade-out';
    boxNode.className = 'popup-box popup-box-zoom-out';
    setTimeout(() => {
      document.body.removeChild(document.querySelector('.popup-content')!);
      document.body.removeEventListener('wheel', wheelHandler);
    }, 300);
  }
};

export const showPosterPopup = (src: string) => {
  if (document.querySelector('.popup-content')) {
    return;
  }
  initPopupStyle();
  document.body.addEventListener('wheel', wheelHandler);
  const closeNode = document.createElement('img');
  closeNode.src = close;
  closeNode.className = 'popup-close-icon';
  const imageNode = document.createElement('img');
  imageNode.src = src;
  imageNode.className = 'popup-poster';
  const textNode = document.createElement('div');
  textNode.innerText = '长按保存图片分享给朋友';
  textNode.className = 'popup-text';
  const boxNode = document.createElement('div');
  boxNode.className = 'popup-box popup-box-zoom-in';
  boxNode.append(closeNode, imageNode, textNode);
  const maskNode = document.createElement('div');
  maskNode.className = 'popup-mask popup-mask-fade-in';
  const contentNode = document.createElement('div');
  contentNode.className = 'popup-content';
  contentNode.append(maskNode, boxNode);
  document.body.append(contentNode);
  maskNode.addEventListener('click', hidePosterPopup);
  closeNode.addEventListener('click', hidePosterPopup);
};
